import styled from '@emotion/styled';
import { ArrowLeft } from '@phosphor-icons/react';

import { Dialog } from '@mui/material';
import { ModalProps } from 'features/modalManager';
import { IconButton } from 'components/button/IconButton';
import { Text } from 'components/text/Text';
import { Button } from 'components/button/Button';

export type FullPageProps = {
  title: string;
  btnTitle: string;
  children?: React.ReactNode;
  formId?: string;
  onClose?: () => void;
  disabledSave?: boolean;
  onClick?: () => void;
  icon?: React.ReactNode;
  modalSx?: ModalProps['modalSx'];
};

export const FullPage = ({
  title,
  btnTitle,
  children,
  onClose,
  disabledSave,
  onClick,
}: FullPageProps) => {
  return (
    <Dialog fullScreen open>
      <Header>
        {onClose && (
          <IconButton onClick={onClose} size="lg">
            <ArrowLeft />
          </IconButton>
        )}
        <Text variant="headlineMd" weight="semiBold">
          {title}
        </Text>
        <Button
          sx={{ marginLeft: 'auto' }}
          variant="primary"
          disabled={disabledSave}
          type="submit"
          onClick={onClick}
        >
          {btnTitle}
        </Button>
      </Header>
      <Container>
        <Body>{children}</Body>
      </Container>
    </Dialog>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${p => p.theme.palette.bg.secondary};
  overflow: auto;
  padding: 48px 200px;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  padding: 24px;
  gap: 24px;
  background-color: ${p => p.theme.palette.bg.primary};
`;

const Body = styled.div`
  display: flex;
  width: 800px;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;
